import { schedulesDataSelector } from "./schedulesDataSelector";
import { RootState } from "../../../store";

export const schedulesExistSelector = (state: RootState): boolean => {
  const schedules = schedulesDataSelector(state);

  return !!schedules?.length;
};
